import { ProjectShareModel } from './project-share.model';

export namespace ProjectAddonModel {
  export enum AddonTarget {
    Plan = 'Plan',
    Camera = 'Camera',
  }

  export interface ModalData {
    target: AddonTarget;
    addon?: ProjectAddonModel.AddonDocument;
    cameraAndLocationIds?: {
      cameraId: string;
      locationId: string;
    }[],
    locationId?: string;
    projectId?: string;
    planId?: string;
  }

  export namespace API {
    export interface CreateAddonDto {
      typeId: string;
      planId?: string;
      cameraId?: string;
      payment?: ProjectShareModel.PaymentType;
      duration?: ProjectShareModel.DurationType;
      retention?: ProjectShareModel.RetentionPeriod;
    }
    export interface AddonTypeResponse {
      _id: string;
      name: string;
      target: AddonTarget;
      isPaymentRequired: boolean;
      isRetentionRequired: boolean;
      createdAt: number;
      updatedAt: number;
    }

    export interface GetAddonTypesParamsDto {
      target?: AddonTarget;
    }

    export interface GetAddonsParamsDto {
      target?: AddonTarget;
    }

    export type CreateDto = Omit<
      AddonDocument,
      '_id' | 'orgId' | 'projectId' | 'locationId' | 'price' | 'target' | 'createdAt' | 'updatedAt'
    >;

    export type UpdateDto = Partial<CreateDto>;

    export type BulkCreateItemDto = CreateDto & {
      locationId: string;
    };

    export interface BulkCreateDto {
      addons: BulkCreateItemDto[];
    }

    export interface BulkUpdateItemDto {
      addonId: string;
      data: Partial<CreateAddonDto>;
    }

    export interface BulkUpdateDto {
      addons: BulkUpdateItemDto[];
    }

    export interface BulkDeleteDto {
      addonIds: string[];
    }
  }

  export interface AddonDocument {
    _id: string;
    orgId: string;
    projectId: string;
    locationId: string;
    typeId: string;
    planId?: string;
    cameraId?: string;
    price: number;
    target: AddonTarget;
    payment?: ProjectShareModel.PaymentType;
    duration?: ProjectShareModel.DurationType;
    retention?: ProjectShareModel.RetentionPeriod;
    createdAt: number;
    updatedAt: number;
  }
}
